import React from 'react';
import { Header } from "semantic-ui-react";

const CustomFieldHeader = () => {
    return (
        <Header
            as="h3"
            style={{ textAlign: "left", display: "inlineBlock" }}>
            Manage Custom Fields
        </Header>
    )
}

export default CustomFieldHeader